import { useTranslation } from "react-i18next";

import { WFPButton } from "@/components/ui/button";

import { deliveryActionsFor } from "../../utils";
import { DeliveryConfirmation, Offer } from "../OfferCard/interfaces";

export type DeliveryDialogKind = "completeDelivery" | "reviewDelivery" | "rejectDelivery";

interface DeliveryActionButtonsProps {
  offer: Offer;
  readOnly?: boolean;
  onDeliveryAction?: (kind: DeliveryDialogKind, offer: Offer) => void;
  size?: "sm";
}

export const DeliveryActionButtons = ({
  offer,
  readOnly = false,
  onDeliveryAction,
  size,
}: DeliveryActionButtonsProps) => {
  const { t } = useTranslation();
  const actions = deliveryActionsFor(offer, readOnly);

  if (!onDeliveryAction) {
    return null;
  }

  return (
    <>
      {actions.reject && (
        <WFPButton
          size={size}
          variant="destructive-secondary"
          onClick={() => onDeliveryAction("rejectDelivery", offer)}
        >
          {t("offerCard.rejectDelivery")}
        </WFPButton>
      )}
      {actions.complete && (
        <WFPButton size={size} onClick={() => onDeliveryAction("completeDelivery", offer)}>
          {t("offerCard.completeDelivery")}
        </WFPButton>
      )}
      {actions.correct && (
        <WFPButton
          size={size}
          variant={
            offer.delivery_confirmation === DeliveryConfirmation.DisputedByAggregator
              ? "default"
              : "secondary"
          }
          onClick={() => onDeliveryAction("completeDelivery", offer)}
        >
          {t("offerCard.correctDelivery")}
        </WFPButton>
      )}
      {actions.review && (
        <WFPButton size={size} onClick={() => onDeliveryAction("reviewDelivery", offer)}>
          {t("offerCard.reviewDelivery")}
        </WFPButton>
      )}
    </>
  );
};
